module.exports = __webpack_public_path__ + "facturaelectronica.svg?b1d245161ff5d23a300e61c088b87f06";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facturaelectronica.svg
// module id = 462
// module chunks = 0